import type { TFunction } from 'i18next';

import { IconNames } from '@sola/schema/lib/icons/icon-names.ts';

import type { RecentActivityItemProps } from './recent-activity-item.tsx';

export enum ActivityType {
  // May want these tied to S2B/B2S...
  Incoming = 'incoming',
  Outgoing = 'outgoing',
  // Not sure this is necessary - seems like it'd just be a "Gift" type... Maybe doesn't even need this...
  Sent = 'sent',
}

export const getComponentRecentActivityItem = (
  args: Pick<
    RecentActivityItemProps,
    'direction' | 'estimatedDelivery' | 'estimatedDeliveryTooltip' | 'ctaHref'
  > & {
    successHeading?: string;
    errorHeading?: string;
    ctaTitle?: string;
    cta?: () => void;
    t: TFunction<'my'>;
  },
) => {
  const {
    direction,
    estimatedDelivery,
    estimatedDeliveryTooltip,
    successHeading,
    errorHeading,
    ctaTitle,
    cta,
    ctaHref,
    t,
  } = args;

  const isShowingDirection = !successHeading;
  const isShowingEstimatedDelivery =
    !successHeading &&
    !errorHeading &&
    !!estimatedDelivery &&
    !!estimatedDeliveryTooltip;

  return {
    isShowingDirection,
    directionLabel: isShowingDirection
      ? t(`my:recentActivity.${direction}`)
      : undefined,
    directionIconName:
      direction === ActivityType.Incoming
        ? IconNames.enum['arrow-square-down']
        : IconNames.enum['arrow-square-right'],
    iconBefore: direction === ActivityType.Incoming,
    isShowingEstimatedDelivery,
    isShowingTracker: !errorHeading,
    isShowingCta: (!!cta || !!ctaHref) && !!ctaTitle,
  };
};
